module.exports = __webpack_public_path__ + "img/logo.e94025bb.gif";